/* ==========================================================
   ELUSA CART DISCOUNT
   Eigene Apply-Logik fuer das Rabattcode-Feld im Warenkorb.
   Ersetzt den vendored theme.js-Pfad (CartDiscountField), der beim
   Ersetzen eines bestehenden Codes alte + neue Codes merged, dadurch
   einen nicht-anwendbaren Code erzeugt und vor dem cart:refresh
   abbricht -> UI aktualisiert sich erst nach Reload.

   Hier: Replace-Semantik (nur der eingetippte Code), und es wird
   IMMER neu gerendert (cart:refresh im Drawer, Reload auf der Cart-Seite).
   ========================================================== */

(() => {
  if (window.__elusaCartDiscount) return;
  window.__elusaCartDiscount = true;

  const SETTLE_TIMEOUT_MS = 9000;
  const SETTLE_INTERVAL_MS = 350;
  const REOPEN_FLAG = 'elusaCartReopen';

  const root = () =>
    (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const isCartPage = () =>
    window.themeVariables &&
    window.themeVariables.settings &&
    window.themeVariables.settings.pageType === 'cart';

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  async function getCart() {
    try {
      const res = await fetch(root() + 'cart.js', { cache: 'no-store' });
      return res.ok ? res.json() : null;
    } catch (e) {
      return null;
    }
  }

  async function postDiscount(discount) {
    try {
      const res = await fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount })
      });
      return res.ok ? res.json() : null;
    } catch (e) {
      return null;
    }
  }

  // Pollt /cart.js, bis sich total_price gegenueber beforeTotal aendert
  // (= Datora hat das Geschenk eingerechnet). true bei Aenderung, false bei Timeout.
  async function waitForRecalc(beforeTotal) {
    if (beforeTotal == null) return false;
    const deadline = Date.now() + SETTLE_TIMEOUT_MS;
    while (Date.now() < deadline) {
      await sleep(SETTLE_INTERVAL_MS);
      const cart = await getCart();
      if (cart && cart.total_price !== beforeTotal) return true;
    }
    return false;
  }

  function render() {
    if (isCartPage()) {
      window.location.reload();
      return;
    }
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      try {
        drawer.show();
      } catch (e) {
        /* noop */
      }
    }
  }

  // APPLY: Code setzen (Replace-Semantik: ersetzt alle vorhandenen Codes),
  // dann per /discount/CODE neu laden. Die Datora-Rabatte werden nur beim
  // Page-Load eingerechnet (nie per Cart-AJAX).
  async function applyDiscount(field) {
    const input = field.querySelector('input[name="discount"]');
    if (!input) return;

    const code = input.value.trim();
    if (!code) return;

    // Replace: alte Codes raus, nur der eingetippte bleibt.
    await postDiscount(code);

    // Drawer nach dem Reload wieder oeffnen.
    try {
      sessionStorage.setItem(REOPEN_FLAG, '1');
    } catch (e) {
      /* noop */
    }
    const path = window.location.pathname + window.location.search;
    window.location.href =
      '/discount/' +
      encodeURIComponent(code) +
      '?redirect=' +
      encodeURIComponent(path);
  }

  // Beim Laden nach einem Apply (Flag gesetzt): Drawer wieder oeffnen und auf
  // Datoras asynchrones Einrechnen warten, dann Cart-UI updaten.
  async function reconcileOnLoad() {
    let active = false;
    try {
      active = sessionStorage.getItem(REOPEN_FLAG) === '1';
      if (active) sessionStorage.removeItem(REOPEN_FLAG);
    } catch (e) {
      /* noop */
    }
    if (!active) return;

    openCartDrawer();

    const cart = await getCart();
    if (!cart) return;

    const changed = await waitForRecalc(cart.total_price);
    if (changed) render();
  }

  document.addEventListener('click', (event) => {
    const applyBtn = event.target.closest('[data-discount-apply]');
    if (!applyBtn) return;
    const field = applyBtn.closest('[data-discount-field]');
    if (field) applyDiscount(field);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest(
      '[data-discount-field] input[name="discount"]'
    );
    if (!input) return;
    event.preventDefault();
    applyDiscount(input.closest('[data-discount-field]'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcileOnLoad);
  } else {
    reconcileOnLoad();
  }
})();
